export default {
  title: 'Динамика продаж недвижимости',
  x_axis: 'Дата',
  y_axis: 'Количество продаж',
  districts: {
    alanya: 'Аланья',
    konyaalti: 'Кониалты',
    kemer: 'Кемер',
    kepez: 'Кепез',
    dosemealti: 'Дёшемеалты',
    finike: 'Финике'
  }
}
